import { Component, Element, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'pn-quote-card',
  styleUrl: 'pn-quote-card.scss',
})
export class PnQuoteCard {
  @Element() hostElement: HTMLElement;
  //props
  @Prop() quote: string = null;
  @Prop() name: string = null;
  @Prop() occupation: string = null;
  render() {
    return (
      <Host>
        <div class="pn-quote-card__section">
          <div class="pn-quote-card__container">
            <slot name="vertical-line"> </slot>
            <div class="pn-quote-card__quote__container">
              <blockquote class="pn-quote-card__quote">
                <svg width="25" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.483 0V7.391C10.483 13.095 6.752 16.961 1.5 18L0.505 15.849C2.937 14.932 4.5 12.211 4.5 10H0.5V0H10.483ZM24.5 0V7.391C24.5 13.095 20.752 16.962 15.5 18L14.504 15.849C16.937 14.932 18.5 12.211 18.5 10H14.517V0H24.5Z"
                    fill="white"
                  />
                </svg>

                {this.quote}
              </blockquote>

              <slot name="horizontal-line"></slot>
              <div class="pn-quote-card__reference__container">
                <slot name="illustration" />
                <div class="pn-quote-card__reference">
                  <span class="pn-quote-card__reference__name">{this.name}</span>
                  <span class="pn-quote-card__reference__occupation">{this.occupation}</span>
                </div>
              </div>
            </div>
            <div class="pn-quote-card__large-photo">
              <slot name="illustration-big" />
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
